import { connect } from 'react-redux'
import MediaBrowse from './MediaBrowse.jsx'
import {
    nextMedia,
    previousMedia,
    jumpToMedia,
    backwardMedia,
    forwardMedia,
    firstMedia,
    lastMedia,
} from '../../../redux/navigation/actions'
import {
    getMediaPosition,
    getMediaCount,
    isPrevMediaNavEnabled,
    isNextMediaNavEnabled,
    isNavigationEnabled,
    isFastNavigationEnabled,
} from '../../../redux/navigation/selectors'
import { getMediaJumpStep } from '../../../redux/configuration/selectors'

const mapStateToProps = state => ({
    currentPosition: Number(getMediaPosition(state)),
    count: getMediaCount(state),
    hasPrevious: isPrevMediaNavEnabled(state),
    hasNext: isNextMediaNavEnabled(state),
    isNavigationEnabled: isNavigationEnabled(state),
    jumpStep: getMediaJumpStep(state),
    isFastNavigationEnabled: isFastNavigationEnabled(state),
})

const mapDispatchToProps = dispatch => ({
    onPrevious: () => dispatch(previousMedia()),
    onNext: () => dispatch(nextMedia()),
    onChange: (position) => dispatch(jumpToMedia(position - 1)),
    onBackward: () => dispatch(backwardMedia()),
    onForward: () => dispatch(forwardMedia()),
    onFirstMedia: () => dispatch(firstMedia()),
    onLastMedia: () => dispatch(lastMedia()),
})

export const MediaBrowseContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MediaBrowse)
